import { render, staticRenderFns } from "./Forwarders.vue?vue&type=template&id=7f6a8e76"
import script from "./Forwarders.vue?vue&type=script&lang=js"
export * from "./Forwarders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports